/**
 * Created by Jerker Nord on 2019-03-07.
 */
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";


export interface IRenderTextureOptions {
    width:number;
    height:number;
    scaleMode:number;
    resolution:number;
}

export class TextureHelper {

    /**
     * Renders a PIXI.Texture from a PIXI.Container
     * @param originalContainer
     * @param resolution
     */
    public static createRenderedTextureFromContainer(originalContainer:PIXI.Container, extraWidth:number = 0, extraHeight:number = 0, resolution:number = NolimitApplication.resolution, forceWidth?:number, forceHeight?:number):PIXI.RenderTexture {
        //Don't use content with negative position!
        const options:IRenderTextureOptions = {
            width : originalContainer.width + extraWidth,
            height :originalContainer.height + extraHeight,
            scaleMode : PIXI.SCALE_MODES.LINEAR,
            resolution :resolution
        };
        if (forceWidth){
            options.width = forceWidth;
        }
        if (forceHeight){
            options.height = forceHeight;
        }
        const renderTexture:PIXI.RenderTexture = PIXI.RenderTexture.create(options);
        NolimitApplication.pixiApp.renderer.render(originalContainer, renderTexture);
        return renderTexture;
    }
}